import {
  FaSalesforce,
  FaMoneyBill,
  FaMoneyBillAlt,
  FaFileInvoice,
} from "react-icons/fa";
import {
  UserOutlined,
  ProductFilled,
  DashboardFilled,
  BankOutlined,
  LogoutOutlined,
  UsergroupAddOutlined,
  BranchesOutlined,
  AlertFilled,
  QuestionCircleOutlined,
  ShoppingOutlined,
} from "@ant-design/icons";
import { Divider } from "antd";
import {
  MdBusinessCenter,
  MdBrandingWatermark,
  MdMoneyOff,
  // MdAdminPanelSettings,
} from "react-icons/md";
import { TiVendorAndroid } from "react-icons/ti";
import { FaMoneyBills, FaMoneyBillTrendUp } from "react-icons/fa6";
import { GiTakeMyMoney, GiReturnArrow, GiRam } from "react-icons/gi";
import { Link } from "react-router-dom";

export const settingsList = [
  {
    key: "Account",
    label: (
      <Link
        to={{
          pathname: "/settings/account",
          state: {
            settingsMode: true,
          },
        }}
        className="h-[100%]"
      >
        Account
      </Link>
    ),
    icon: <UserOutlined />,
  },
  {
    key: "manageBusiness",
    label: (
      <Link
        to={{
          pathname: "/settings/manage-business",
          state: {
            settingsMode: true,
          },
        }}
        className="h-[100%]"
      >
        Manage Business
      </Link>
    ),
    icon: <MdBusinessCenter />,
  },
  {
    key: "manageUsers",
    label: (
      <Link
        to={{
          pathname: "/settings/manage-users",
          state: {
            settingsMode: true,
          },
        }}
        className="h-[100%]"
      >
        Manage Users
      </Link>
    ),
    icon: <UsergroupAddOutlined />,
  },
  {
    key: "brand",
    label: (
      <Link
        to={{
          pathname: "/settings/brand",
          state: {
            settingsMode: true,
          },
        }}
        className="h-[100%]"
      >
        Brand
      </Link>
    ),
    icon: <MdBrandingWatermark />,
  },
  {
    key: "ram",
    label: (
      <Link
        to={{
          pathname: "/settings/ram",
          state: {
            settingsMode: true,
          },
        }}
        className="h-[100%]"
      >
        RAM
      </Link>
    ),
    icon: <GiRam />,
  },
  {
    key: "grade",
    label: (
      <Link
        to={{
          pathname: "/settings/grade",
          state: {
            settingsMode: true,
          },
        }}
        className="h-[100%]"
      >
        Grade
      </Link>
    ),
    icon: <BranchesOutlined />,
  },
  {
    key: "reminders",
    label: (
      <Link
        to={{
          pathname: "/settings/reminders",
          state: {
            settingsMode: true,
          },
        }}
        className="h-[100%]"
      >
        Reminders
      </Link>
    ),
    icon: <AlertFilled />,
  },
  {
    key: "helpSupport",
    label: (
      <Link
        to={{
          pathname: "/settings/help-support",
          state: {
            settingsMode: true,
          },
        }}
        className="h-[100%]"
      >
        Help & Support
      </Link>
    ),
    icon: <QuestionCircleOutlined />,
  },
  // {
  //   type: "divider",
  // },
];

export const items = [
  {
    key: "general",
    label: "General",
  },
  {
    key: "dashboard",
    label: "Dashboard",
    pathname: "/dashboard",
    // children: [],
    icon: <DashboardFilled />,
  },
  {
    key: "parties",
    label: "Parties",
    pathname: "/parties",
    // children: [],
    icon: <UserOutlined />,
  },
  {
    key: "items",
    label: "Items",
    pathname: "/items",

    // children: [],
    icon: <ProductFilled />,
  },
  // {
  //   key: "masters",
  //   label: "Masters",
  //   icon: <MdAdminPanelSettings />,
  //   children: [
  //     {
  //       key: "brand",
  //       label: "Brand",
  //       pathname: "/masters/brand",

  //       // children: [],
  //       icon: <MdBrandingWatermark />,
  //     },
  //     {
  //       key: "ram",
  //       label: "RAM",
  //       pathname: "/masters/ram",

  //       // children: [],
  //       icon: <GiRam />,
  //     },
  //     {
  //       key: "grade",
  //       label: "Grade",
  //       pathname: "/masters/grade",

  //       // children: [],
  //       icon: <BranchesOutlined />,
  //     },
  //   ],
  // },
  {
    key: "sales",
    label: "Sales",
    icon: <FaSalesforce />,
    children: [
      {
        key: "salesInvoices",
        label: "Sales Invoices",
        pathname: "/sales-invoice",
        icon: <FaFileInvoice />,
      },
      // {
      //   key: "quotationEstimation",
      //   label: "Quotation/Estimation",
      //   pathname: "/quotation-estimation",
      //   icon: <LuFileQuestion />,
      // },
      {
        key: "paymentIn",
        label: "Payment In",
        pathname: "/payment-in",
        icon: <GiTakeMyMoney />,
      },
      {
        key: "salesReturn",
        label: "Sales Return",
        pathname: "/sales-return",
        icon: <GiReturnArrow />,
      },
      // {
      //   key: "creditNote",
      //   label: "Credit Note",
      //   pathname: "/credit-note",
      //   icon: <FaMoneyBills />,
      // },
    ],
  },

  {
    key: "purchase",
    label: "Purchase",
    icon: <ShoppingOutlined />,
    children: [
      {
        key: "vendor",
        label: "Vendor/Supplier",
        pathname: "/vendor-supplier",
        icon: <TiVendorAndroid />,
      },
      {
        key: "purchaseInvoice",
        label: "Purchase Invoices",
        pathname: "/purchase-invoice",
        icon: <FaMoneyBill />,
      },
      {
        key: "purchasePriceUpdate",
        label: "Price Update",
        pathname: "/purchase/price-update",
        icon: <FaMoneyBillTrendUp />,
      },
      {
        key: "paymentOut",
        label: " Payment Out",
        pathname: "/payment-out",
        icon: <MdMoneyOff />,
      },
      // {
      //   key: "purchaseReturn",
      //   label: "Purchase Return",
      //   pathname: "/purchase-return",
      //   icon: <MdKeyboardReturn />,
      // },
      // {
      //   key: "debitNote",
      //   label: " Debit Note",
      //   pathname: "/debit-note",
      //   icon: <FaMoneyCheck />,
      // },
      // {
      //   key: "purchaseOrders",
      //   label: "Purchase Orders",
      //   pathname: "/purchase-orders",
      //   icon: <SiMarketo />,
      // },
    ],
  },
  {
    key: "reports",
    label: "Reports",
    pathname: "/reports-dashboard",
    icon: <BankOutlined />,
  },
  {
    key: "accountingSolutions",
    label: "Accounting Solutions",
  },
  {
    key: "cashBank",
    label: "Cash & Bank",
    pathname: "/cash-bank",
    icon: <BankOutlined />,
  },
  // {
  //   key: "eInvoicing",
  //   label: "E-Invoicing",
  //   pathname: "/e-invoicing",
  //   icon: <FaFileInvoice />,
  // },
  // {
  //   key: "automatedBills",
  //   label: "Automated Bills",
  //   pathname: "/automated-bills",
  //   icon: <FaPiggyBank />,
  // },
  {
    key: "expenses",
    label: "Expenses",
    pathname: "/expenses",
    icon: <FaMoneyBillAlt />,
  },
];

export const profileDetails = (
  <div className="hover:rounded-md hover:mr-[-3px] hover:bg-black-200 flex justify-between w-[120px] cursor-pointer">
    <div className="text-start mt-1">
      <Link
        to={{
          pathname: "/profile",
          state: { row: "", data: "login" },
        }}
      >
        <p className="flex text-[14px] font-semibold">
          <UserOutlined className="mr-2" /> Profile
        </p>
      </Link>
      <Divider className="w-[210%] mt-[8px] mb-[8px] ml-[-10px]" />
      <p className="flex text-[14px] font-semibold">
        <Link
          to={{
            pathname: "/login",
            state: { row: "", data: "login" },
          }}
          onClick={() => {
            localStorage.setItem("accountDetails", "");
            localStorage.setItem("userDetails", "");
            localStorage.setItem("authToken", "");
            localStorage.setItem("user", "");
            localStorage.setItem("authData", "");
          }}
        >
          <LogoutOutlined className="mr-2" /> Logout
        </Link>
      </p>
      {/* <p className="mt-1 text-[12px]">
          Quickly add all your Parties with Excel
        </p> */}
    </div>
    {/* <BiRightArrowAlt size={24} /> */}
  </div>
);
